import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";

import { selectInvoicingSteps } from "../../store/selectors/navigation";
import { selectNewInvoices } from "../../store/selectors/invoicing";
import { getAppUser, setInvoicingSteps } from "../../store/actions/navigation";
import { MemoPanelComponent } from "../../components/invPreselPanel";

function NewInvoicesPreselect() {
  const invoicingSteps = useSelector(selectInvoicingSteps);
  const newInvoices = useSelector(selectNewInvoices);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAppUser());
    dispatch(
      setInvoicingSteps({
        ...invoicingSteps,
        twinfieldId:
          invoicingSteps.twinfieldId === ""
            ? `GZN-${new Date().getFullYear()}-`
            : invoicingSteps.twinfieldId,
      }),
    );
  }, [dispatch, newInvoices]);

  let selectedInvoices = [];
  if (invoicingSteps.singleInvoices) {
    selectedInvoices = newInvoices
      .filter(
        (invoice) =>
          invoicingSteps.includedInvoicesIds.includes(invoice.id) &&
          !invoice.collective_invoice,
      )
      .map((invoice) => {
        console.log(invoice);
        return {
          customer: invoice.customer,
          twinfield_id: invoice.twinfield_id,
          language: invoice.language,
          agent: invoice.agent,
          vatReverse: invoice.transfer_vat,
          message: invoice.message,
          state: invoice.state,
          dirtyOrders: invoice.dirtyOrders,
          subInvoices: [
            {
              id: invoice.id,
              description: invoice.description,
              invoiceLines: invoice.invoiceLines,
            },
          ],
        };
      })
      .sort(
        (a, b) =>
          a.subInvoices[0].description.split("\n")[3].split(" ")[2] -
          b.subInvoices[0].description.split("\n")[3].split(" ")[2],
      );
  } else if (invoicingSteps) {
    let collectiveTwinFieldIds = [
      ...new Set(
        newInvoices
          .filter(
            (invoice) =>
              invoicingSteps.includedInvoicesIds.includes(invoice.id) &&
              invoice.collective_invoice,
          )
          .map((invoice) => invoice.twinfield_id),
      ),
    ];
    for (let org of collectiveTwinFieldIds) {
      let orgInvoices = newInvoices.filter(
        (invoice) => invoice.twinfield_id === org,
      );

      let genDescBit = {
        "en-GB": {
          reverse: "Collective invoice with VAT reverse charged (BTW verlegd).",
          nonReverse: "Collective invoice.",
        },
        "nl-NL": {
          reverse: "Verzamelfactuur met BTW verlegd.",
          nonReverse: "Verzamelfactuur.",
        },
        "de-DE": {
          reverse:
            "Sammelrechnung mit Reverse-Charge-Mehrwertsteuer (BTW verlegd).",
          nonReverse: "Sammelrechnung.",
        },
      };
      let collectiveDirtyOrders = [];
      for (let orgInvoice of orgInvoices) {
        console.log(collectiveDirtyOrders);

        for (let order of orgInvoice.dirtyOrders) {
          if (
            !collectiveDirtyOrders.map((order) => order.id).includes(order.id)
          ) {
            collectiveDirtyOrders.push(order);
          }
        }
        // collectiveDirtyOrders = [
        //   ...collectiveDirtyOrders,
        //   ...orgInvoice.dirtyOrders,
        // ];
      }

      selectedInvoices.push({
        customer: orgInvoices[0].customer,
        agent: orgInvoices[0].agent,
        twinfield_id: orgInvoices[0].twinfield_id,
        language: orgInvoices[0].language,
        vatReverse: orgInvoices[0].transfer_vat,
        generalDesc: orgInvoices[0].transfer_vat
          ? genDescBit[orgInvoices[0].language].reverse
          : genDescBit[orgInvoices[0].language].nonReverse,
        dirtyOrders: collectiveDirtyOrders,
        subInvoices: orgInvoices
          .filter((invoice) =>
            invoicingSteps.includedInvoicesIds.includes(invoice.id),
          )
          .map((invoice) => {
            return {
              id: invoice.id,
              description: invoice.description,
              invoiceLines: invoice.invoiceLines,
            };
          })
          .sort(
            (a, b) =>
              a.description.split("\n")[3].split(" ")[2] -
              b.description.split("\n")[3].split(" ")[2],
          ),
      });
    }
    selectedInvoices.sort(
      (a, b) =>
        a.subInvoices[0].description.split("\n")[3].split(" ")[2] -
        b.subInvoices[0].description.split("\n")[3].split(" ")[2],
    );
  }
  return (
    <div className="invoicingBody">
      {selectedInvoices.length > 0 ? (
        <button
          className="newInvoiceSelector"
          onClick={() => {
            dispatch(
              setInvoicingSteps({
                ...invoicingSteps,
                invoiceIndex: invoicingSteps.invoiceIndex - 1,
                twinfieldId:
                  invoicingSteps.twinfieldId === ""
                    ? `GZN-${new Date().getFullYear()}-`
                    : invoicingSteps.twinfieldId,
              }),
            );
          }}
          disabled={invoicingSteps.invoiceIndex < 1}
        >
          {"<"}
        </button>
      ) : (
        ""
      )}
      {selectedInvoices.length > 0
        ? `${invoicingSteps.invoiceIndex + 1}/${selectedInvoices.length}`
        : ""}
      {selectedInvoices.length > 0 ? (
        <button
          className="newInvoiceSelector"
          onClick={() => {
            dispatch(
              setInvoicingSteps({
                ...invoicingSteps,
                invoiceIndex: invoicingSteps.invoiceIndex + 1,
                twinfieldId:
                  invoicingSteps.twinfieldId === ""
                    ? `GZN-${new Date().getFullYear()}-`
                    : invoicingSteps.twinfieldId,
              }),
            );
          }}
          disabled={invoicingSteps.invoiceIndex + 1 >= selectedInvoices.length}
        >
          {">"}
        </button>
      ) : (
        ""
      )}
      {selectedInvoices.length > 0
        ? console.log(selectedInvoices[invoicingSteps.invoiceIndex])
        : console.log("oko")}
      {selectedInvoices.length > 0 ? (
        <MemoPanelComponent
          customer={selectedInvoices[invoicingSteps.invoiceIndex].customer}
          message={selectedInvoices[invoicingSteps.invoiceIndex].message}
          state={selectedInvoices[invoicingSteps.invoiceIndex].state}
          twinfieldId={
            selectedInvoices[invoicingSteps.invoiceIndex].twinfield_id
          }
          generalDesc={
            selectedInvoices[invoicingSteps.invoiceIndex].generalDesc
          }
          subInvoices={
            selectedInvoices[invoicingSteps.invoiceIndex].subInvoices
          }
          language={selectedInvoices[invoicingSteps.invoiceIndex].language}
          agent={selectedInvoices[invoicingSteps.invoiceIndex].agent}
          vatReverse={selectedInvoices[invoicingSteps.invoiceIndex].vatReverse}
          selectedInvoicesLength={selectedInvoices.length}
          invIndex={invoicingSteps.invoiceIndex}
          dirtyOrders={
            selectedInvoices[invoicingSteps.invoiceIndex].dirtyOrders
          }
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default NewInvoicesPreselect;
